/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from '../types/index';

function IllustStatusResourceMulti({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 200 200"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fill="#B6BAC1"
        fillRule="evenodd"
        d="M113.294 40.809c6.84 0 12.463 5.23 13.093 11.907 6.841.465 12.25 6.167 12.25 13.127v28.97a1.25 1.25 0 0 1-2.5 0v-28.97c0-5.883-4.773-10.658-10.653-10.658H71.922c-5.88 0-10.653 4.775-10.653 10.658v73.702c0 5.883 4.774 10.657 10.653 10.657h26.686a1.25 1.25 0 0 1 0 2.5H71.922c-6.84 0-12.465-5.23-13.094-11.908-6.84-.466-12.248-6.167-12.248-13.125V55.956c0-8.364 6.78-15.147 15.142-15.147zm-51.572 2.5c-6.98 0-12.642 5.663-12.642 12.647v71.713c0 5.558 4.26 10.123 9.689 10.611V65.843c0-7.263 5.892-13.158 13.153-13.158h51.947c-.634-5.28-5.128-9.376-10.575-9.376z"
        clipRule="evenodd"
      />
      <path
        fill="#FAE100"
        d="M128.319 161c16.819 0 30.452-13.639 30.452-30.463s-13.633-30.463-30.452-30.463c-16.818 0-30.452 13.639-30.452 30.463S111.501 161 128.32 161"
      />
      <path
        fill="#F9FAFB"
        d="M124.679 144.318v1.578a2.847 2.847 0 0 0 2.847 2.847h1.576a2.847 2.847 0 0 0 2.847-2.847v-1.578a2.847 2.847 0 0 0-2.847-2.847h-1.576a2.847 2.847 0 0 0-2.847 2.847m4.423-30.283h-1.587a2.837 2.837 0 0 0-2.836 2.837v17.984a2.836 2.836 0 0 0 2.836 2.836h1.587a2.836 2.836 0 0 0 2.836-2.836v-17.984a2.837 2.837 0 0 0-2.836-2.837"
      />
    </svg>
  );
}
export default IllustStatusResourceMulti;
